import { render, staticRenderFns } from "./chooseCards.vue?vue&type=template&id=57036138&scoped=true&"
import script from "./chooseCards.vue?vue&type=script&lang=js&"
export * from "./chooseCards.vue?vue&type=script&lang=js&"
import style0 from "./chooseCards.vue?vue&type=style&index=0&id=57036138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57036138",
  null
  
)

export default component.exports